import { useState } from "react";
import { BRANCHES, PROGRAM_OPTIONS, SCHOOL_HOURS } from "../data/siteContent";

const FAQS = [
  {
    id: 1,
    q: "What age group do you accept for admission?",
    a: "We welcome children from 1 year onward across Day Care, Toddler Program, Play Group, Nursery, Jr KG, and Sr KG.",
  },
  {
    id: 2,
    q: "Is the school environment safe for children?",
    a: "Yes. Your child's safety is our highest priority, and we maintain a secure, caring environment where children can learn and play with confidence.",
    defaultOpen: true,
  },
  {
    id: 3,
    q: "What are your school timings?",
    a: `${SCHOOL_HOURS.statusLabel}: ${SCHOOL_HOURS.openToday}. ${SCHOOL_HOURS.schoolTime}. ${SCHOOL_HOURS.sunday}.`,
  },
  {
    id: 4,
    q: "Which programs do you offer?",
    a: PROGRAM_OPTIONS.join(", "),
  },
  {
    id: 5,
    q: "How do you communicate important updates to parents regularly?",
    a: "We use dedicated parent communication channels and regular updates to keep families informed about progress, events, and school news.",
  },
  {
    id: 6,
    q: "Do you have more than one branch?",
    a: `${BRANCHES[0].name}: ${BRANCHES[0].address}. ${BRANCHES[1].name}: ${BRANCHES[1].address}.`,
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState(2);

  return (
    <section className="w-full bg-white px-4 py-14 md:px-8 lg:px-16">
      <div className="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row">
        <div className="w-full md:w-5/12">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-gray-200 px-4 py-1 text-sm font-medium text-gray-700">
            <span className="text-lg font-black text-[#FF6B35]">*</span>
            Frequently Asked Questions
          </div>

          <h2 className="mb-8 text-3xl font-extrabold leading-tight text-[#0D1B2A] md:text-4xl">
            Your important question answered right here
          </h2>

          <div className="overflow-hidden rounded-2xl shadow-md">
            <div className="bg-[#1B4D6E] p-5">
              <div className="mb-4 flex items-start gap-3">
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#FF6B35]">
                  <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" stroke="white" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9 9a3 3 0 015.12 2.1c0 2-3 3-3 3" strokeLinecap="round" />
                    <circle cx="12" cy="17" r="0.5" fill="white" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-extrabold text-white">Find quick answers to common questions</p>
                </div>
              </div>

              <div className="flex flex-col gap-4 sm:flex-row">
                <div className="flex items-center gap-2">
                  <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4 flex-shrink-0" stroke="white" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.09 11" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className="text-sm text-white">+91-76187 59333</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4 flex-shrink-0" stroke="white" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" strokeLinecap="round" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  <span className="text-sm text-white">preethi@seekersbay.in</span>
                </div>
              </div>
            </div>

            <div className="bg-[#FF6B35] px-5 py-4 text-white">
              {BRANCHES.map((branch) => (
                <div key={branch.id} className="flex items-start gap-3 py-1">
                  <svg viewBox="0 0 24 24" fill="none" className="mt-0.5 h-5 w-5 flex-shrink-0" stroke="white" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  <span className="text-sm font-extrabold">{branch.name}: {branch.address}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex w-full flex-col gap-3 md:w-7/12">
          {FAQS.map((faq) => {
            const isOpen = openId === faq.id;

            return (
              <div
                key={faq.id}
                className={`overflow-hidden rounded-2xl border transition-all duration-200 ${
                  isOpen ? "border-[#1B4D6E] bg-[#1B4D6E]" : "border-gray-200 bg-white"
                }`}
              >
                <button
                  onClick={() => setOpenId(isOpen ? null : faq.id)}
                  className="flex w-full items-center justify-between px-5 py-4 text-left"
                >
                  <span className={`text-sm font-semibold md:text-base ${isOpen ? "text-white" : "text-[#0D1B2A]"}`}>
                    {faq.id}. {faq.q}
                  </span>
                  <div className={`ml-3 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full ${isOpen ? "bg-[#FF6B35]" : "bg-[#1B4D6E]"}`}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      className={`h-4 w-4 transition-transform duration-200 ${isOpen ? "rotate-45" : ""}`}
                      stroke="white"
                      strokeWidth="2.5"
                    >
                      {isOpen ? (
                        <path d="M12 5v14M5 12h14" strokeLinecap="round" />
                      ) : (
                        <path d="M19 9l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round" />
                      )}
                    </svg>
                  </div>
                </button>

                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-blue-100">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
